import { Oval, ThreeDots } from "react-loader-spinner";

function CustomLoader() {
  return (
    <div className="h-100 d-flex justify-content-center align-items-center">
      <ThreeDots
        className="position-absolute"
        height={50}
        width={50}
        color="#660099"
        ariaLabel="loading"
        stroke="red"
      />
    </div>
  );
}

export default CustomLoader;
